import {Component, ViewEncapsulation} from "@angular/core";
import {WidgetComponent} from "../widget.component";
import {isUndefined} from "util";
@Component({
  selector: 'app-widget',
  // host: {
  //   '(document:click)': 'handleClick($event)',
  // },
  templateUrl: 'default-widget.component.html',
  styleUrls: ['../../styles.css', 'color-scheme.css', '../../ng2-select.css'],
  encapsulation: ViewEncapsulation.None
})
export class DefaultWidgetComponent extends WidgetComponent {


}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/payment-widget/default-widget/default-widget.component.ts